// extracted by mini-css-extract-plugin
export var typingIndicator = "_pp-0";